import {useEffect} from 'react'
import {MainBox, ChartContainer} from './TimeSeriesDashboardStyle'
import RiskOverTimeComponent from './RiskOverTimeComponent/RiskOverTimeComponent'
import PopulationOverTimeComponent from './PopulationOverTimeComponent/PopulationOverTimeComponent'
import PropTypes from 'prop-types'
import {useChartMarker} from '../store/hooks/chartMarker'
import {CHART_NAMES} from './Config/config'
import {useAnalyticsPageLoad} from '../hooks/useAnalyticsPageLoad'
export default function TimeSeriesDashboardComponent({setIsTimeSeriesOpen}) {
  const {chartMarkers} = useChartMarker()

  useEffect(() => {
    setIsTimeSeriesOpen(true)
    return () => {
      chartMarkers.current = {
        [CHART_NAMES.RISK]: {lineLabels: {}, annotations: {}},
        [CHART_NAMES.POPULATION]: {lineLabels: {}, annotations: {}}
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useAnalyticsPageLoad('Time Series')

  return (
    <MainBox component='main'>
      <ChartContainer>
        <RiskOverTimeComponent />
      </ChartContainer>
      <ChartContainer>
        <PopulationOverTimeComponent />
      </ChartContainer>
    </MainBox>
  )
}
TimeSeriesDashboardComponent.propTypes = {
  setIsTimeSeriesOpen: PropTypes.func.isRequired
}
